import { type OptionType } from '@on3/ui-lib/components/AutoComplete/AutoComplete';
import { CityAutoComplete } from '@on3/ui-lib/components/AutoComplete/CityAutoComplete';
import { ProfileDetailsContext } from '@public/components/Modals/Player/Details';
import { useContext } from 'react';

export const DetailsHometown = () => {
  const { values, errors, handleUpdate } = useContext(ProfileDetailsContext);

  return (
    <div>
      <CityAutoComplete
        error={errors['hometown.hometownCityKey']}
        label="Hometown"
        name="hometown"
        onChange={(h: OptionType[]) =>
          handleUpdate('hometown', {
            ...values.hometown,
            hometownCityKey: h[0]?.key,
            hometownCityName: h[0]?.label,
          })
        }
        value={[
          {
            key: values.hometown.hometownCityKey ?? 0,
            label: values.hometown.hometownCityName ?? '',
          },
        ].filter((h) => !!h.key)}
      />
    </div>
  );
};
